import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { Language } from '../../types/locale';

export interface LocaleState {
	language: Language,
}

const initialState: LocaleState = {
	language: "da-DK",
}

export const localeSlice = createSlice({
	name: 'locale',
	initialState,
	reducers: {
		setLanguage: (state, action: PayloadAction<Language>) => {
			state.language = action.payload;
		},
	},
});

export const { setLanguage } = localeSlice.actions;
export default localeSlice.reducer;
